export default {
  methods : {
    removeAutocompletes(){
      const el = this.$el;
      setTimeout(()=>{
        el.querySelectorAll('input:not([autocompleted])').forEach(input => {
          input.setAttribute('name', Math.random().toString(32).slice(2));
          input.setAttribute('autocompleted','true')
        });
      },100);
    }
  },
  updated(){
    this.removeAutocompletes();
  },
  mounted(){
    this.removeAutocompletes();
  },
}
